import { useMsal } from "@azure/msal-react";
import React, { createContext, useContext } from "react";

// 1. Context erstellen
const M365Context = createContext();

// 2. Provider Komponente
export const M365Provider = ({ children }) => {
   const { instance } = useMsal();

   const meineFunktion = (name) => {
      console.log(`Hallo ${name}, die Funktion wurde global aufgerufen!`);
   };

   async function getMsGraph(token, graphEndpoint, type) {
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      // Add additional fields here
      if (type === "file") {
         return fetch(graphEndpoint, {
            method: "Get",
            headers,
         })
            .then((response) => response.blob())
            .catch((err) => {
               console.log(err);
            });
      } else {
         return fetch(graphEndpoint, {
            method: "Get",
            headers,
         }).then((response) => response.json());
      }
   }

   async function getSharepointFile(itemId, driveId) {
      //"https://graph.microsoft.com/v1.0/drives/b!EhEjbZqX-k-9jBNIW-jPYLQgpHJ54z1Hkv6Ql9NddPQbBRk5Qc3GSqcHCrljXD2i/items/"
      if (itemId && driveId) {
         let graphEndpoint = "https://graph.microsoft.com/v1.0/drives/" + driveId + "/items/" + itemId + "/content";

         console.log(graphEndpoint);

         const tokenResponse = await instance.acquireTokenSilent({}).then((respo) => {
            return respo;
         });
         const fileResponse = await getMsGraph(tokenResponse.accessToken, graphEndpoint, "file");

         return fileResponse;
      }
   }

   async function getMS365User(mailName) {
      let graphEndpoint = "https://graph.microsoft.com/v1.0/users/" + mailName + "@baurimmo.onmicrosoft.com";

      console.log(graphEndpoint);

      const tokenResponse = await instance.acquireTokenSilent({}).then((respo) => {
         return respo;
      });
      const response = await getMsGraph(tokenResponse.accessToken, graphEndpoint);
      return response;
   }

   async function startSharepointUploadSession(accessToken, driveId, parentFolderId, fileName) {
      // URL für die Erstellung der Session
      const url = `https://graph.microsoft.com/v1.0/drives/${driveId}/items/${parentFolderId}:/${fileName}:/createUploadSession`;

      const response = await fetch(url, {
         method: "POST",
         headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
         },
         body: JSON.stringify({
            item: {
               "@microsoft.graph.conflictBehavior": "rename", // Falls Datei existiert, automatisch (1) anhängen
            },
         }),
      });

      const sessionData = await response.json();
      return sessionData.uploadUrl; // Diese URL ist ca. 15 Min gültig
   }

   async function uploadBlobToSession(uploadUrl, blob) {
      const fileSize = blob.size;

      const response = await fetch(uploadUrl, {
         method: "PUT",
         headers: {
            "Content-Length": fileSize,
            "Content-Range": `bytes 0-${fileSize - 1}/${fileSize}`,
         },
         body: blob,
      });
      console.log(response);

      if (response.ok) {
         const result = await response.json();
         console.log("Datei erfolgreich erstellt:", result.name);
         return result;
      } else {
         throw new Error("Upload fehlgeschlagen");
      }
   }

   async function uploadFileToSharepoint(editedBlob, driveId, folderId, fileName) {
      try {
         const tokenResponse = await instance.acquireTokenSilent({}).then((respo) => {
            return respo;
         });
         console.log({ accesstoken: tokenResponse.accessToken, driveId, folderId, fileName });

         // 2. Session anfordern
         const uploadUrl = await startSharepointUploadSession(tokenResponse.accessToken, driveId, folderId, fileName);

         console.log(uploadUrl);

         // 3. Datei hochladen
         const result = await uploadBlobToSession(uploadUrl, editedBlob);

         return result;

         alert(`Gespeichert als: ${result.name}`);
      } catch (error) {
         console.error("Fehler beim Upload-Prozess:", error);
      }
   }

   async function getSharepointData(myFolderName, myDriveId) {
      if (myFolderName) {
         const msRequest = {
            scopes: [],
         };
         let responseArray = [];
         let responseObject = { [myDriveId]: {} };
         const tokenResponse = await instance
            .acquireTokenSilent(msRequest)
            .then((respo) => {
               return respo;
            })
            .catch((err) => {
               console.log("errorsilenttoken:");
               console.error(err);
               const popupToken = instance
                  .acquireTokenPopup(msRequest)
                  .then((respo) => {
                     return respo;
                  })
                  .catch((err) => {
                     console.log(err);
                  });

               return popupToken;
            });

         let graphEndpoint = `https://graph.microsoft.com/v1.0/drives/${myDriveId}/root:/${myFolderName}:/children?$expand=thumbnails`;
         /* let graphEndpoint =
            "https://graph.microsoft.com/v1.0/drives/b!EhEjbZqX-k-9jBNIW-jPYLQgpHJ54z1Hkv6Ql9NddPQbBRk5Qc3GSqcHCrljXD2i/root:/" +
            myFolderName +
            ":/children?$expand=thumbnails"; //get all files in folder */
         const mainFolderResponse = await getMsGraph(tokenResponse.accessToken, graphEndpoint)
            .then((data) => {
               return data.value;
            })
            .catch((err) => {
               console.log("Error: getMsSharepointData:");
               console.error(err);
            });
         // console.log(mainFolderResponse);

         responseObject[myDriveId] = mainFolderResponse.reduce((oldObj, item) => ({ ...oldObj, [item.id]: item }), {});
         // console.log(responseObject);

         for await (const item of mainFolderResponse) {
            responseArray.push(item);

            if (item.folder) {
               graphEndpoint = `https://graph.microsoft.com/v1.0/drives/${myDriveId}/root:/${myFolderName}/${item.name}:/children?$expand=thumbnails`;
               /* graphEndpoint =
                  "https://graph.microsoft.com/v1.0/drives/b!EhEjbZqX-k-9jBNIW-jPYLQgpHJ54z1Hkv6Ql9NddPQbBRk5Qc3GSqcHCrljXD2i/root:/" +
                  myFolderName +
                  "/" +
                  item.name +
                  ":/children?$expand=thumbnails"; //get all files in folder */
               let subFolderResponse = await getMsGraph(tokenResponse.accessToken, graphEndpoint)
                  .then((data) => {
                     responseObject[myDriveId][item.id]["children"] = data.value.reduce(
                        (oldObj, item) => ({ ...oldObj, [item.id]: item }),
                        {},
                     );

                     return data.value.map((item2) => ({
                        ...item2,
                        parentFolder: item.name,
                     }));
                  })
                  .catch((err) => {
                     console.log("Error: getMsSharepointData:");
                     console.error(err);
                  });

               responseArray.push(...subFolderResponse);
            }
         }
         // console.log(responseObject);

         return { flatArray: responseArray, objectTree: responseObject };
      }
   }

   async function postMsTeamsTeamMessage(teamId, channelId, messagedata) {
      //https://teams.microsoft.com/l/channel/19%3Abcef8ed598784d59a10ca7fa950d2c86%40thread.tacv2/Gruppe2?groupId=5f9e0c1e-8a83-4cd1-a2d7-51dfc4825f87&tenantId=f6e03af0-f62c-4ef2-a542-c02a29109b93
      //https://teams.microsoft.com/l/channel/19%3AYNwftqCSumkZQWvYUYqmBWweNLGHZMRkeGKANCoE0fI1%40thread.tacv2/Testkanal21?groupId=5f9e0c1e-8a83-4cd1-a2d7-51dfc4825f87&tenantId=f6e03af0-f62c-4ef2-a542-c02a29109b93
      //groupId=5f9e0c1e-8a83-4cd1-a2d7-51dfc4825f87
      if (teamId && channelId) {
         // const teamId = "5f9e0c1e-8a83-4cd1-a2d7-51dfc4825f87";
         let graphEndpoint =
            "https://graph.microsoft.com/v1.0/teams/" + teamId + "/channels/" + channelId + "/messages";
         const auth = {};

         const tokenResponse = await instance.acquireTokenSilent(auth).then((respo) => {
            return respo;
         });
         const graphResponse = await postMsGraph(tokenResponse.accessToken, messagedata, graphEndpoint).then((data) => {
            return data;
         });
         return graphResponse;
      }
   }
   async function postMsGraph(token, data, graphEndpoint) {
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-type", "application/json");

      return fetch(graphEndpoint, {
         method: "Post",
         headers,
         body: JSON.stringify(data),
      })
         .then((response) => response.json())
         .catch((err) => {
            console.log(err);
         });
   }

   return (
      <M365Context.Provider
         value={{
            postMsTeamsTeamMessage,
            getMS365User,
            meineFunktion,
            getSharepointData,
            getSharepointFile,
            uploadFileToSharepoint,
         }}
      >
         {children}
      </M365Context.Provider>
   );
};

// 3. Custom Hook für einfacheren Zugriff (optional, aber empfohlen)
export const useM365Context = () => useContext(M365Context);
